// extracted by mini-css-extract-plugin
export default {"fadeOut":"style_fadeOut__nFrpX","fadeout":"style_fadeout__zcB89","frame":"style_frame__yS0q-","opac":"style_opac__F29O8"};